import { render, staticRenderFns } from "./AddFacescan.vue?vue&type=template&id=01846590&scoped=true&"
import script from "./AddFacescan.vue?vue&type=script&lang=js&"
export * from "./AddFacescan.vue?vue&type=script&lang=js&"
import style0 from "./AddFacescan.vue?vue&type=style&index=0&id=01846590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01846590",
  null
  
)

export default component.exports